export const en = {
  // Navigation
  nav: {
    about: "About Me",
    portfolio: "Portfolio", 
    resume: "Resume",
    werkwijze: "Process",
    contact: "Contact"
  },

  // About Section
  about: {
    eyebrow: "About Me",
    title: "Web Developer & Designer",
    hello: "Online",
    lead: "Shaping the future of web & AI · Software visionary · AI innovator. I turn ideas into reality with thoughtful design and reliable code.",
    tags: {
      frontend: "Frontend (80%)",
      backend: "Backend (10%)",
      ai: "Artificial Intelligence (10%)"
    },
    kpis: {
      experience: "Years Experience",
      hours: "Hours of Work",
      projects: "Projects Completed"
    }
  },

  // Portfolio Section
  portfolio: {
    eyebrow: "Portfolio",
    title: "My Work",
    viewDesign: "View Design",
    projects: {
      ventilation: "Ventilation Company Website",
      aiPlanner: "AI Planner App Design",
      fulfillment: "Fulfillment Company Website",
      aiSignatures: "AI Signatures App Design",
      glass: "Glass Company Website"
    }
  },

  // Resume Section
  resume: {
    title: "Resume",
    subtitle: "Education & Experience",
    education: {
      title: "Education",
      bachelor: {
        title: "Bachelor's Degree",
        school: "University of Amsterdam",
        period: "2023 – 2026",
        description: "Focus on software engineering & AI."
      },
      vwo: {
        title: "VWO",
        school: "Lyceum Kralingen",
        period: "2017 – 2023",
        description: "Focus on mathematics, physics, chemistry, and biology."
      }
    },
    experience: {
      title: "Experience",
      frontend: {
        title: "Frontend Developer",
        company: "Freelance",
        period: "2023 – Present",
        description: "Development of modern web applications with React.js, HTML, CSS, SCSS, and Python. Focus on responsive design and user experience."
      },
      webdev: {
        title: "Web Developer",
        company: "Freelance",
        period: "2023 – Present",
        description: "Built websites and web applications with HTML, CSS, SCSS, and JavaScript. Experience with Python for backend development and data analysis."
      }
    }
  },

  // Werkwijze Section
  werkwijze: {
    eyebrow: "Process",
    title: "How I Work",
    documentTitle: "Process Document",
    pages: "pages",
    open: "Open",
    download: "Download"
  },

  // Contact Section
  contact: {
    eyebrow: "Contact",
    title: "Get In Touch",
    form: {
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      namePlaceholder: "Your name",
      emailPlaceholder: "your.email@example.com",
      subjectPlaceholder: "Project inquiry",
      messagePlaceholder: "Tell me about your project...",
      submit: "Send Message",
      sending: "Sending...",
      sent: "Sent! ✓",
      error: "Error - Try Again"
    },
    success: "Thank you for your message! I'll get back to you as soon as possible.",
    error: "An error occurred while sending your message. Please try again or contact me directly at info@mouadkasmi.com.",
    info: {
      email: "info@mouadkasmi.com",
      location: "Amsterdam, Netherlands"
    }
  },

  // Footer
  footer: {
    copyright: "© 2024 Mouad Kasmi. All rights reserved."
  }
};
